import React from "react";
import { getClientbyLcationAsync } from "../../../api/Dashboard";
import DonaPorGrupo from "./DonaPorGrupo";

const ClientsByLocation = () => (
  <DonaPorGrupo
    titulo="Clientes por municipio"
    obtener={getClientbyLcationAsync}
    nombre={(item) => item.location || item.abrev}
    columna="Municipio"
    unidad={["cliente", "clientes"]}
    descripcionVacio="Aquí se muestran los clientes por municipio."
  />
);

export default ClientsByLocation;
